module.exports = __webpack_public_path__ + "assets/-_10.5b84d385.svg";